import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GenericResponse } from '../models/generic-response';
import { GetPasswordParameters, PasswordConfiguration } from '../models/parametrizacion-api.model';
import { environment } from 'src/environments/environment';
import { map, Observable, firstValueFrom, switchMap } from 'rxjs';
import { adaptPasswordParametrizationConfiguration, adaptPasswordParametrizationConfigurationToPayload } from '../adapters/password-adapters-response';
import { ObtenerBitacora } from '../models/bitacora-response.model';
import { Helperclass } from '../class/helperclass';

@Injectable({
  providedIn: 'root'
})
export class ParametrizacionApiService {
  readonly #http = inject(HttpClient);
  readonly #helperClass = inject(Helperclass);

  #getModules$ = this.#helperClass.activeModules$

  get url() {
    return environment.urlService;
  }

  getPasswordParameters(): Observable<PasswordConfiguration> {
    const payload = {
      payload: {
        ruta: 'getConfParametrizacion'
      }
    }

    return this.#http.post<GenericResponse<GetPasswordParameters, null>>(`${this.url}`, payload)
      .pipe(
        map(({ responseObject }) => adaptPasswordParametrizationConfiguration(responseObject))
      )
  }

  getBitacora() {
    return this.#getModules$.pipe(
      map(modules => modules.find(m => m.key === 'CONFIGURACIÓN')),
      switchMap(getConfigurationModule => {
        const payload = {
          payload: {
            ruta: 'getLastParamBitacora',
            idModulo: getConfigurationModule?.idModulo
          }
        };

        return this.#http.post<GenericResponse<ObtenerBitacora, null>>(
          this.url,
          payload
        );
      }),
      map(({ responseObject }) => responseObject)
    );
  }

  sendPasswordParameters(value: PasswordConfiguration): Observable<string> {
    const payload = {
      payload: {
        ruta: 'updateConfParam',
        configParam: {
          ...adaptPasswordParametrizationConfigurationToPayload(value),
          idAgente: sessionStorage.getItem('agentID')
        }
      }
    }

    return this.#http.post<GenericResponse<string, null>>(`${this.url}`, payload)
      .pipe(
        map(({ responseObject }) => responseObject)
      )
  }
}
